<template>
  <div>
    <AutocompleteInputContainer/>
    <div v-show="showAutocompletePopup"
         id="smartsearch-autocomplete__popup-container"
         class="smartsearch-autocomplete__popup-container q-shadow q-p-2 q-bg-body q-rounded q-bg-white"
    >
      <OverlayLoader :loading="loading"/>
      <LinearLoader :loading="loading"/>
      <AutocompleteContent/>
    </div>
  </div>

</template>

<script setup lang="ts">
import {onMounted, toRefs, onUnmounted} from 'vue';
import {usePopupStore} from "@/store/AutocompletePopup/PopupStore";

import AutocompleteInputContainer from '@/components/AutocompletePopup/AutocompleteInputContainer.vue';
import LinearLoader from '@/components/LinearLoader.vue';
import OverlayLoader from '@/components/OverlayLoader.vue';
import AutocompleteContent from '@/components/AutocompletePopup/AutocompleteContainer.vue';
import {useMobileViewStore} from "@/store/MobileViewStore";

const popupStore = usePopupStore()
const {showAutocompletePopup, loading} = toRefs(popupStore)
const mobileViewStore = useMobileViewStore();


onUnmounted(() => {
  window.removeEventListener('resize', mobileViewStore.updateIsMobileView);
});

onMounted(() => {
  window.addEventListener('resize', mobileViewStore.updateIsMobileView);
  document.addEventListener('click',(event)=> popupStore.handleClickOutside(event));
});
</script>

<style>


/*@import "bootstrap/dist/css/bootstrap.min.css";*/
#smartsearch-autocomplete {
  font-size:1em;
}
.q-overlay {
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.4);
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  padding: 5%;
}

#smartsearch-autocomplete *{
  font-family: sans-serif;
}
.smartsearch-autocomplete__popup-container:before {
  position: absolute;
  content: '';
  width: 20px;
  height: 20px;
  background: white;
  display: block;
  z-index: -1;
  left: 50%;
  top: -6px;
  transform: rotate(45deg);
}

.smartsearch-autocomplete__popup-container {
  position: absolute;
  min-width: 960px;
  max-width: 960px;
  background: #fff;
  color: #343a40;
  z-index: 10000;
  min-height: 500px;
  left: 50%;
  transform: translate(-50%, 0);
}


@media (max-width: 767px) {
  .smartsearch-autocomplete__popup-container {
    max-width: 100vw;
    min-width: unset !important;
    height: calc(100dvh - 60px);
    overflow-y: scroll;
    overflow-x: hidden;
    left: unset;
    transform: unset;
  }

  .q-autocomplete-active {
    overflow: hidden;
    position: fixed;
    width: 100%;
    height: 100%;
  }

  .q-autocomplete-active #smartsearch-autocomplete {
    position: fixed;
    background: #f8f9fa;
    top: 0;
    left: 0;
    z-index: 1080;
    right: 0;
    bottom: 0;
    padding-top: 15px;
    max-width: 100vw;
  }
}


@media (min-width:768px) and (max-width: 1080px) {
  .smartsearch-autocomplete__popup-container {
    position: absolute;
    min-width: 100vw;
    max-width: 100vw;
    width: 100vw;
    background: #fff;
    color: #343a40;
    z-index: 10000;
    min-height: 500px;
    left: 50%;
    transform: translate(-50%, 0);
  }

  /*.q-autocomplete-active {*/
  /*  overflow: hidden;*/
  /*  position: fixed;*/
  /*  width: 100%;*/
  /*  height: 100%;*/
  /*}*/

  /*.q-autocomplete-active #smartsearch-autocomplete {*/
  /*  position: fixed;*/
  /*  background: #f8f9fa;*/
  /*  top: 0;*/
  /*  left: 0;*/
  /*  z-index: 1080;*/
  /*  right: 0;*/
  /*  bottom: 0;*/
  /*  padding-top: 15px;*/
  /*  max-width: 100vw;*/
  /*}*/
}


</style>
